<template>
  <div class="chips" v-if="examples.length">
    <button
      v-for="ex in examples"
      :key="ex"
      class="chip"
      type="button"
      @click="$emit('select', ex)"
    >{{ ex }}</button>
  </div>
</template>

<script>
// 预设示例快捷填入（线上版交互特点：一键填入降低使用门槛）
export default {
  name: 'ExampleChips',
  props: {
    examples: { type: Array, default: () => [] },
  },
};
</script>
